import PlansData from "./PlansData";
import PropertiesData from "./PropertiesData";

export const tabDetails = (view: string, selectedListType: string, selectedList: any) => {
  return [
    {
      label: "Properties",
      content: Hoc(PropertiesData, view, selectedListType, selectedList)
    },
    {
      label: "Plans",
      content: Hoc(PlansData, view, selectedListType, selectedList)
    }
  ];
};

function Hoc(WrappedComponent: any, view: string, selectedListType: string, selectedList: any) {
  return function () {
    return <WrappedComponent view={view} selectedListType={selectedListType} selectedList={selectedList} />;
  };
}
